import { observer } from "mobx-react";
import {
  preventNegativeOnKeyboard,
  preventPaste,
} from "../../../utils/helpers";

export interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  iconSrc: string;
  iconAlt: string;
  enableMaxAmountButton?: boolean;
  maxAmountHandler?: () => void;
}

function Input({
  title,
  onChange,
  iconSrc,
  iconAlt,
  name,
  value,
  disabled,
  ref,
  enableMaxAmountButton = false,
  maxAmountHandler
}: InputProps) {
  return (
    <div>
      <div className="text-xs text-[#fff] flex  justify-between">
        <span >{title}</span>
        {enableMaxAmountButton && <button onClick={maxAmountHandler} >Max Amount</button>}
      </div>

      <div className="relative">
        <input
          name={name}
          ref={ref}
          disabled={disabled}
          onChange={onChange}
          onKeyDown={preventNegativeOnKeyboard}
          onPaste={preventPaste}
          type="number"
          value={value}
          className="appearance-none block w-full bg-white border border-gray-300 rounded-md py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        />
        <img
          className="absolute right-3 top-1/2 transform -translate-y-1/2"
          src={iconSrc}
          alt={iconAlt}
        />
      </div>
    </div>
  );
}

export default observer(Input);
